<template>
  <validation-observer ref="refProvidingFormObserver" #default="{ invalid }">
    <b-modal
        id="cash-register-modal"
        v-model="openModal"
        size="lg"
        ok-only
        ok-title="Fermer"
        centered
        title="Transfert de fond vers une caisse"
    >
      <b-form @submit.prevent="saveTransaction" @reset="resetForm">
        <b-row class="mb-2">
          <b-col cols="6">
            <!-- providing register -->
            <validation-provider
                #default="{ errors }"
                name="sub-register"
                rules="required"
            >
              <b-form-group
                  label="Choix du compte / caisse à approvisionner"
                  label-for="sub-register"
              >
                <v-select
                    v-model="transac.sub_cash_register"
                    label="name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="registersList"
                    :reduce="(o) => o.uid"
                    :clearable="false"
                    placeholder="Sélectionnez ou Recherchez ici..."
                    input-id="sub-register"
                >
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                      Pas de résultat pour <em>{{ search }}</em
                    >.
                    </template>
                    <em v-else style="opacity: 0.5">Recherche un compte...</em>
                  </template>
                </v-select>
                <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mb-2">

          <b-col cols="8">
            <!-- amount -->
            <validation-provider
                #default="{ errors }"
                name="Montant"
                :rules="`required|min-amount:0|max-amount:${selectedRegister ? selectedRegister.amount : 1}`"
            >
              <b-form-group
                  label-for="providing-amount"
                  :state="errors.length > 0 ? false : null"
              >
                <template #label>
                  <span class="float-left">Montant d'approvisionnement (XOF)</span>
                  <i v-if="transac.sub_cash_register" class="float-right text-truncate"
                  >Solde après approvisionnement :<span class="ml-1 text-primary font-weight-bolder">{{
                      amountToCurrency(remainInRegister)
                    }}</span></i
                  >
                </template>
                <b-form-input
                    v-model="transac.amount"
                    id="providing-amount"
                    type="number"
                    placeholder="Le montant de paiement"
                    :state="errors.length > 0 ? false : null"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <!-- designation -->
        <validation-provider #default="{ errors }" name="Détails">
          <b-form-group
              label="Détails sur le transfert"
              label-for="designation"
              :state="errors.length > 0 ? false : null"
          >
            <b-form-textarea
                v-model="transac.designation"
                id="designation"
                :state="errors.length > 0 ? false : null"
            />
            <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <div class="mt-3">
          <hr/>
          <b-button
              size="sm"
              class="mr-1"
              type="submit"
              variant="primary"
              :disabled="isLoading || invalid"
          >
            <b-spinner v-if="isLoading" small/>
            Enregistrer
          </b-button>
          <b-button
              size="sm"
              type="reset"
              variant="outline-secondary"
              :disabled="isLoading"
              @click="openModal = false"
          >Annuler
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </validation-observer>
</template>
<script>
import {
  BRow,
  BCol,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormTextarea,
  BSpinner, BModal,
} from "bootstrap-vue";

import vSelect from "vue-select";

import {ValidationObserver, ValidationProvider} from "vee-validate";
import {createNamespacedHelpers} from "vuex";
import {amountToCurrency} from "@/utils/formatAmount";

const {mapGetters, mapMutations, mapActions} =
    createNamespacedHelpers("dedicatedFund");

export default {
  name: "CashRegisterDetailsModalProvidingForm",
  components: {
    BModal,
    BRow,
    BCol,
    BForm,
    BButton,
    BSpinner,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,

    vSelect,
    ValidationObserver,
    ValidationProvider,
  },
  props: ["showContent", "concernedRegisterType", "loading"],
  data() {
    return {
      transac: this.defaultForm(),
    };
  },
  watch: {
    getError: {
      handler: function (val) {
        if (val) {
          this.$emit(
              "cash-register-handled",
              val.message,
              "AlertTriangleIcon",
              "danger"
          );
          this.handleErrors(val.error);
        }
      },
      immediate: true,
      deep: true,
    },
    openModal: {
      handler: function (val) {
        this.resetForm()
        if (val) { // on opening
          this.getAllSubCashRegisters();
        } else { // on closing
          this.resetForm();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    isLoading: {
      get() {
        return this.loading;
      },
      set(value) {
        this.$emit("update:loading", value);
      },
    },
    openModal: {
      get() {
        return this.showContent;
      },
      set(value) {
        this.$emit("update:showContent", value);
      },
    },
    ...mapGetters({
      registersList: "concernedRegisters",
      getError: "errors",
    }),
    selectedRegister() {
      if (this.transac?.sub_cash_register) {
        return this.registersList.find(
            (a) => a.uid === this.transac.sub_cash_register
        );
      }
      return null;
    },
    remainInRegister() {
      let currAmount = 0;
      if (this.selectedRegister) currAmount = parseInt(this.selectedRegister.amount);
      currAmount += parseInt(this.transac.amount);

      return currAmount;
    },
  },
  methods: {
    amountToCurrency,
    ...mapActions(["fetchDedicatedFund", "getAllSubCashRegisters"]),
    ...mapMutations({
      setError: "SET_ERRORS",
    }),
    handleErrors(errors) {
      for (const [field, message] of Object.entries(errors)) {
        this.$refs.refProvidingFormObserver.setErrors({[field]: message[0]});
      }
    },
    async saveTransaction() {
      this.isLoading = true;
      this.setError(null);
      try {
        this.transac.from_cash_register = true;
        this.$emit("addTransac", this.transac);
      } catch (e) {
        console.log(e);
      }
    },
    resetForm() {
      this.defaultForm();
      this.setError(null);
    },
    defaultForm() {
      return ({
        is_from_dedicated_fund: true,
        transaction: "debit",
        type: "transfer",
        amount: 0,
        designation: "",
        sub_cash_register: null
      });
    }
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
